var _path, _circle, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.614,15.832c.467-1.677,2.123-2.916,4.095-2.916s3.627,1.239,4.095,2.916"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.709,
    cy: 7.731,
    r: 2.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.537,18.887c.564-2.538,3.005-4.448,5.93-4.448,2.905,0,5.332,1.883,5.918,4.395"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.467,
    cy: 7.972,
    r: 2.832
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.bf20640d9a9d28754251cfcc3beddc90.svg";
export { ForwardRef as ReactComponent };